import React, {Component} from "react";
import PropTypes from "prop-types";
import * as players from "./players/";
import TagManager from './../../../js/utils/tagManager';

class Player extends Component {
  constructor(props) {
    super(props)

    this.player = null;
    this.videotype = this.props.videotype;
    this.videoid = this.props.videoid;
    this.state = {
      open: false,
      player: null,
      doneYT: false
    }

    Player.instances.push(this);
  }

  componentDidMount() {
    if (!this.setupPlayer())
      return;

    if (!this.props.image)
      this.loadImage();
    this.props.proxy.querySelector('.inline-player--container__image-container').onclick = this.openVideo.bind(this)
  }

  setupPlayer() {
    let p = players[this.videotype];
    if (!p)
      return false;

    this.player = new p(this.videoid, this.props.proxy.querySelector('.inline-player .player'))
    this.player.onPlayCallback = this.onPlay.bind(this);
    this.player.onStopCallback = this.onStop.bind(this);
    return true;
  }

  loadImage() {
    this.player.imageURL.then((image) => {
      this.props.proxy.querySelector('.inline-player--container__image-container').style.backgroundImage = "url('" + image + "')"
    });
  }

  onStop(){
    if (this.state.open) {
      this.setState({open: false})
      this.props.proxy.querySelector('.inline-player--container__image-container').style.display = "block";
      this.stop();

      let headerContainer = document.querySelector('.header-article');
      if (hasParent(this.props.proxy, headerContainer)) {
        TweenMax.to(headerContainer.querySelector('.inline-copyright-container'), 0.5, {opacity: 1});
      }
    }
  }

  openVideo() {
    if (!this.state.open) {
      this.setState({open: true})
      this.props.proxy.querySelector('.inline-player--container__image-container').style.display = "none";
      this.player.play();

      let headerContainer = document.querySelector('.header-article');
      if (hasParent(this.props.proxy, headerContainer)) {
        TweenMax.to(headerContainer.querySelector('.inline-copyright-container'), 0.5, {opacity: 0});
      }

    }
  }

  stop() {
    if (this.player)
      this.player.stop();
  }

  onPlay() {
    TagManager.pushEvent('clic-article-video', 'Contenu', 'Embed_video', this.videotype + '-' + this.videoid);
    Player.stopAll(this)
  }

  render() {
    return <div></div>
  }
}

Player.instances = [];

Player.stopAll = (except) => {
  Player.instances.forEach((player) => {
    if (player !== except) {
      player.stop();
    }
  })
}

Player.propTypes = {
  videotype: PropTypes.string,
  videoid: PropTypes.string
}

export default(Player)

const hasParent = (target, parent) => {
  if (!target)
    return false;
  if (target === parent)
    return true;
  return hasParent(target.parentElement, parent);
}


// WEBPACK FOOTER //
// ./vendor/bbs/crt/src/resources/views/components/player/Player.js